import { render, staticRenderFns } from "./CoverLetter.vue?vue&type=template&id=6d2ff627&scoped=true&lang=pug&v-cloak=true"
import script from "./CoverLetter.vue?vue&type=script&lang=ts"
export * from "./CoverLetter.vue?vue&type=script&lang=ts"
import style0 from "./CoverLetter.vue?vue&type=style&index=0&id=6d2ff627&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ff627",
  null
  
)

export default component.exports